const toCompletedInput = (completed) =>
  (completed ?? []).map(({ type, value }) => ({ type, value }));

/**
 * Sparse `ServiceReportInput` of one card: the values of `fieldNames` (direct fields of
 * `serviceReport`, e.g. `hakLockedState`) plus the card states `completed`. Photos have their own
 * mutations (see feature page projekt-protokolle).
 */
export const toServiceCardInput = (serviceReport, fieldNames) => ({
  ...Object.fromEntries(
    fieldNames.map((fieldName) => [fieldName, serviceReport?.[fieldName] ?? null])
  ),
  completed: toCompletedInput(serviceReport?.completed),
});
